import { render, staticRenderFns } from "./test_cxkq3.vue?vue&type=template&id=a2a163a4&scoped=true&"
import script from "./test_cxkq3.vue?vue&type=script&lang=js&"
export * from "./test_cxkq3.vue?vue&type=script&lang=js&"
import style0 from "./test_cxkq3.vue?vue&type=style&index=0&id=a2a163a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a163a4",
  null
  
)

export default component.exports